/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export const defaultTaskData = {
	crewSize: 2,
	durationDays: 1,
	left: 0,
	top: 0,
	height: 270,
	width: 290,
	workingDays: [true],
};
export const defaultConstraintData = {
	left: 0,
	top: 0,
	height: 270,
	width: 290,
	type: 'constraint',
};
export const defaultMilestoneData = {
	left: 0,
	top: 0,
	height: 270,
	width: 290,
	type: 'milestone',
};
